module.exports = __webpack_public_path__ + "img/nfpoa-tela01_corte.f3d91801.png";